import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./EntityNotFound.scss";

import notFoundIcon from "./img/not found.png";

export default function EntityNotFound({
  title = "Контент недоступний",
  text = "Ймовірно, автор видалив або архівував цей контент.",
  showBack = false,
  showHome = true,
  onBack = null,
  onHome = null,
  homeTo = "/",
  icon = "🔍",
  iconSrc = notFoundIcon,
  lockScroll = true,
}) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (typeof onBack === "function") return onBack();
    try {
      if (window.history.length > 1) navigate(-1);
      else navigate(homeTo);
    } catch {
      navigate(homeTo);
    }
  };

  const handleHome = () => {
    if (typeof onHome === "function") return onHome();
    navigate(homeTo);
  };

  useEffect(() => {
    if (!lockScroll) return;
    const body = document.body;
    const prev = body.style.overflow;
    body.style.overflow = "hidden";
    return () => {
      body.style.overflow = prev || "";
    };
  }, [lockScroll]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") handleHome();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="entity-notfound" role="dialog" aria-modal="true">
      <div className="entity-notfound-card" onClick={(e) => e.stopPropagation()}>
        <div className="entity-notfound-icon" aria-hidden="true">
          {iconSrc ? (
            <img
              src={iconSrc}
              alt=""
              className="entity-notfound-icon-img"
              draggable={false}
            />
          ) : (
            icon
          )}
        </div>

        <h2 className="entity-notfound-title">{title}</h2>
        <p className="entity-notfound-text">{text}</p>

        <div className="entity-notfound-actions">
          {showBack && (
            <button className="entity-notfound-btn secondary" onClick={handleBack}>
              Назад
            </button>
          )}

          {showHome && (
            <button className="entity-notfound-btn primary" onClick={handleHome}>
              На головну
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
